export default __webpack_public_path__ + "static/media/Combined Shape.3b9903fa.svg";